import {IApp} from "@/interfaces/app.interface";
import {INotification} from "@/interfaces/notification.interface";
import {IProfilePayment} from "@/modules/Profile/interfaces/profile-payment.interface";
import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
import {httpResource} from "@/resources/http.resource";
import store from "@/store/store";
import {bus} from "@/plugins/bus";
import {IBalance} from "@/modules/Payment/interfaces/balance.interface";
import {IHome} from "@/modules/Home/interfaces/home.interface";

export class PaymentResource {

  async getCardList() {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.BankCards;
      const params: any = {
        command: IProfilePayment.Command.CardList,
      };
      const response = await httpResource.httpAction({ action, params });
      return response.data.result;
    };
    const { response } = await store.dispatch('defaultResourceAction', { asyncAction });
    return response;
  }

  async addNewCard({carNumber}: {carNumber: string | undefined}) {
    let prepareUrl = (status: string) => {
      const hostUrl = window.location.origin;
      // const profileUrl = IApp.RoutePath[IApp.ROUTE_NAME.PAGE_PROFILE];
      // const queryString = `?${INotification.RouteKey.Notice}=${IProfilePayment.NoticeKey.SaveCard}&${IProfilePayment.NoticeKey.Status}=${status}`;
      // const hash = `#${IProfile.PageTab.Payment}`;
      // return `${hostUrl}${profileUrl}${queryString}${hash}`;
      const resultPageUrl = IApp.RoutePath[IApp.ROUTE_NAME.PAGE_PAYMENT_RESULT];
      return `${hostUrl}${resultPageUrl}?type=saveCard&status=${status}`;
    };

    let asyncAction = async () => {
      const action = IProfilePayment.Action.BankCards;
      const params: any = {
        command: IProfilePayment.Command.StartNewCard,
        returnUrl: prepareUrl(INotification.NoticeStatus.Success),
        failUrl: prepareUrl(INotification.NoticeStatus.Error),
      };
      if (carNumber) params.carNumber = carNumber;
      const response = await httpResource.httpAction({ action, params });
      await store.dispatch('dialog/openDialog', {
        blockName: 'payment',
        dialogName: 'bankIframePopup',
        payload: {
          iframeUrl: response.data.result.formURL,
          closeAction: () => {
            bus.$emit(IBalance.Events.OpenPaymentResultPage, {
              type: 'saveCard',
              status: 'success',
              orderUid: response.data.result.orderUid,
            });
          },
        }
      });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async setDefaultCard(cardId: number) {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.BankCards;
      const params: any = {
        command: IProfilePayment.Command.SetDefault,
        bankCardLinkId: cardId,
      };
      await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async removeCard(cardId: number) {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.BankCards;
      const params: any = {
        command: IProfilePayment.Command.RemoveCard,
        bankCardLinkId: cardId,
      };
      await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async setPaymentSettings(dataSettings: any) {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.BankCards;
      const params: any = {
        command: IProfilePayment.Command.SetSettings,
        ...dataSettings,
      };
      await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async checkCardAdd(orderUid: string) {
    let asyncAction = async () => {
      const action = IBalance.ACTION_PAY;
      const params: any = {
        command: IProfilePayment.Command.GetBankPays,
        orderUid: orderUid,
      };
      return await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async updateCarsPaymentList(carId: number, add: boolean) {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.CarsForPayment;
      const params: any = {
        command: add ? IProfilePayment.Command.Add : IProfilePayment.Command.Delete,
        carId,
      };
      return await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async addAllCarsToPayment() {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.CarsForPayment;
      const params: any = { command: IProfilePayment.Command.AddAllFavoriteCars };
      return await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async getFavoriteCars() {
    let asyncAction = async () => {
      const action = IHome.Action;
      const params: any = { command: IHome.Command.GetMyCars };
      return await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

  async getSelectedCarsForPayment() {
    let asyncAction = async () => {
      const action = IProfilePayment.Action.CarsForPayment;
      const params: any = { command: IProfilePayment.Command.Get };
      return await httpResource.httpAction({ action, params });
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }

}

export const paymentResource = new PaymentResource();